import TextField from './components/text-field'
import TextArea from './components/textarea'
import SelectField from './components/select'
import RadioField from './components/radio'
import CheckboxField from './components/checkbox'
import MultiCheckboxField from './components/multicheckbox'
import BaseField from './mixins/basefield'

const components = {
    TextField,
    TextArea,
    SelectField,
    RadioField,
    CheckboxField,
    MultiCheckboxField
}

components.install = (Vue, options = {}) => {
    for (const componentName in components) {
        const component = components[componentName]

        if (component && componentName !== 'install') {
            Vue.component(component.name, component)
        }
    }
}

export { BaseField }

export default components


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit-fields/src/main.js
// module id = null
// module chunks = 